import { useCallback, useState } from "react";
import {
  DEFAULT_DOCUMENT_UPLOAD_MODE,
  isBundleDocumentUploadMode,
  type DocumentUploadMode,
} from "./types";

export function useDocumentUploadMode(
  initialMode: DocumentUploadMode = DEFAULT_DOCUMENT_UPLOAD_MODE
) {
  const [uploadMode, setUploadMode] = useState<DocumentUploadMode>(initialMode);
  const isBundleMode = isBundleDocumentUploadMode(uploadMode);

  const resetUploadMode = useCallback(() => {
    setUploadMode(DEFAULT_DOCUMENT_UPLOAD_MODE);
  }, []);

  return {
    uploadMode,
    setUploadMode,
    isBundleMode,
    resetUploadMode,
  };
}
